module.exports = __webpack_public_path__ + "img/1 (98).a0241959.png";